/**
 * Design Tokens: Shapes
 * 
 * Este arquivo contém as definições de formas (bordas, etc.) utilizadas pelos temas.
 * Segue o princípio do Atomic Design como tokens fundamentais.
 */

const shapes = {
  common: {
    borderRadius: 8,
    borderWidth: 1
  },
  light: {
    borderRadius: 8
  },
  dark: {
    borderRadius: 8
  },
  moonstone: {
    borderRadius: 8
  },
  sepia: {
    borderRadius: 8
  },
  cyberPurple: {
    borderRadius: 12
  },
  instagram: {
    borderRadius: 12
  }
};

export default shapes;
export { shapes };
